// Module
var code = "<div class=\"vui-stepper\">\n    <div class=\"vui-stepper__steps\" ng-transclude=\"steps\"></div>\n\n    <div class=\"vui-stepper__spaces\">\n        <hr ng-repeat=\"space in $ctrl.spacers\">\n    </div>\n\n    <div class=\"vui-stepper__content\" ng-transclude=\"contents\"></div>\n</div>\n";
// Exports
module.exports = code;